import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';

import { OAuthClient } from '@app/models';
import { NotyService } from '@app/services';

export type ModalResult = void;
export interface ModalPublicProperties {
  client: OAuthClient;
}

@Component({
  selector: 'app-oauth-client-credentials-modal',
  templateUrl: './oauth-client-credentials-modal.component.html',
  styleUrls: ['./oauth-client-credentials-modal.component.scss'],
  standalone: false
})
export class OAuthClientCredentialsModalComponent implements ModalPublicProperties {
  @Input() client: OAuthClient;

  constructor(
    public modal: NgbActiveModal,
    private clipboardService: ClipboardService,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}

  copyToClipboard(content?: string) {
    if (!content) {
      return;
    }

    this.clipboardService.copyFromContent(content);
    this.notyService.success(this.translateService.instant('shared.textCopySuccess'), 2000);
  }
}
